const ROUTE_ROOT = ''
export const ROUTE_INDEX = `${ROUTE_ROOT}/`

export const ROUTE_PREVIEW_DASHBOARD = `${ROUTE_ROOT}/dashboard`
export const ROUTE_PREVIEW_ORDERS = `${ROUTE_ROOT}/orders`
export const ROUTE_PREVIEW_BILLING = `${ROUTE_ROOT}/billing`
export const ROUTE_PREVIEW_REPORTS = `${ROUTE_ROOT}/payout-report`

const ROUTE_SERVICES = `${ROUTE_ROOT}/services`
export const ROUTE_SHIPMENTS = `${ROUTE_SERVICES}/shipments`
// this is an external Url used by backend for deep linking from emails
export const ROUTE_SHIPMENT_DETAILS = `${ROUTE_SHIPMENTS}/:shipmentId`
